import { useMsal } from "@azure/msal-react";
import {
    Grid,
    Typography,
    Button,
    Paper,
    TextField,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Add } from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import React, { useEffect } from "react"
import { NavLink } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useStyles } from "./geraeteManagementStyles";
import {
    selectNewMode, selectEditMode,
    selectGeraetDaten, selectMessstelleDaten, selectRouterDaten, setGeraetDaten, setRouterDaten, setMessstelleDaten,
    emptyGeraet, emptyMessstelle, emptyRouter, selectMessgeraetLoading, selectMessstelleLoading, selectRoutergeraetLoading,
    selectMessstellen, selectMessgeraete, selectRouter,
} from "./geraeteManagementSlice";
import { globalStyles } from "../../assets/globalStyles";
import { toUTCDateStringWithoutTime } from '../../utils/utils';
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { getMessgeraettypen, selectMessgeraettypListe } from "../administration/werteliste/messgeraettypen/messgeraettypenSlice";
import { getRoutergeraettypen, selectRoutergeraettypListe } from "../administration/werteliste/routergeraettypen/routergeraettypenSlice";
import { messgeraettyp, routergeraettyp } from "../../utils/apiTypes";
import { getUWs, updateAktuelleMessstelle } from "../administration/messstellen/messstellenSlice";
import { updateAktuellesMessgeraet } from "../administration/messgeraete/messgeraeteSlice";
import { updateAktuellesRoutergeraet } from "../administration/routergeraet/routergeraetSlice";

const InbetriebnahmeDatumAnzeige = ({ inbetriebnahmedatum, isUTC }: { inbetriebnahmedatum: string | null, isUTC: boolean }): JSX.Element => {
    if (inbetriebnahmedatum) {
        if (isUTC) return (<React.Fragment>{toUTCDateStringWithoutTime(new Date(inbetriebnahmedatum))}</React.Fragment>)
        return (<React.Fragment>{new Date(inbetriebnahmedatum).toLocaleDateString()}</React.Fragment>);
    } else {
        return (<React.Fragment />);
    }
};

export const Messpunkt: React.FC = () => {
    const dispatch = useAppDispatch();

    const { instance } = useMsal();


    useEffect(() => {
        dispatch(getMessgeraettypen());
        dispatch(getRoutergeraettypen());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };
    const [selectedMessstelleInputValue, setSelectedMessstelleInputValue] = React.useState("");
    const [selectedMessgeraetInputValue, setSelectedMessgeraetInputValue] = React.useState("");
    const [selectedRouterInputValue, setSelectedRouterInputValue] = React.useState("");

    const messstellen = useAppSelector(selectMessstellen);
    const messgeraete = useAppSelector(selectMessgeraete);
    const router = useAppSelector(selectRouter);

    const messgeraettypListe = useAppSelector(selectMessgeraettypListe);
    const routergeraettypListe = useAppSelector(selectRoutergeraettypListe);


    const messstelleLoading = useAppSelector(selectMessstelleLoading);
    const messgeraetLoading = useAppSelector(selectMessgeraetLoading);
    const routergeraetLoading = useAppSelector(selectRoutergeraetLoading);

    const messstelleDaten = useAppSelector(selectMessstelleDaten);
    const messgeraetDaten = useAppSelector(selectGeraetDaten);
    const routergeraetDaten = useAppSelector(selectRouterDaten);


    const newMode = useAppSelector(selectNewMode);
    const editMode = useAppSelector(selectEditMode);

    const isUTC = useAppSelector(selectDate);

    function getMessgeraetTyp(messgeraettypListe: Array<messgeraettyp>) {
        return messgeraettypListe.filter(x => messgeraetDaten.typ == x.id);
    }

    function getRoutergeraetTyp(routergeraettypListe: Array<routergeraettyp>) {
        return routergeraettypListe.filter(x => routergeraetDaten.typ == x.id);
    }


    return (
        <Grid container item md={12} spacing={2} style={{ paddingLeft: "16px", paddingRight: "5px", marginTop: "10px" }} >
            <Grid item md={4}>
                <Paper>
                    <Grid item container md={12}>
                        <Accordion expanded={editMode || newMode} style={{ height: "100%", width: "100%", marginBottom: "-5px" }}>
                            <AccordionSummary
                                expandIcon={<React.Fragment>
                                    <Button component={NavLink} to="/geraeteverwaltung/messstellen" onClick={() => {dispatch(getUWs()); dispatch(updateAktuelleMessstelle(messstelleDaten))}}>
                                        { newMode || editMode ? <AddIcon data-cy="add-messstellen-button" fontSize="large" className={classes.accordionSummary} /> : <EditIcon  fontSize="small" className={classes.accordionSummary}/> }
                                    </Button>
                                </React.Fragment>}>
                                <Typography className={classes.tableHeadline} variant="h6" >Messstelle</Typography>
                            </AccordionSummary>
                            {newMode ?
                                <AccordionDetails>
                                    <Autocomplete
                                        fullWidth
                                        id="select-messstelle"
                                        value={messstelleDaten}
                                        noOptionsText={<React.Fragment>
                                            {messstelleLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine unzugeordneten Messstellen"}</React.Fragment>}
                                        onChange={(event, newValue) => dispatch(setMessstelleDaten(newValue ? newValue : emptyMessstelle))}
                                        inputValue={selectedMessstelleInputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setSelectedMessstelleInputValue(newInputValue);
                                        }}
                                        options={messstellen}
                                        getOptionLabel={(option) => (option.name != "" ? (option.name + " (" + option.schaltfeld + ")") : "")}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Messstelle"
                                                InputLabelProps={{ ...params.InputLabelProps }}
                                                InputProps={{ ...params.InputProps }}
                                                variant="outlined"
                                            />
                                        )}

                                        disabled={editMode || newMode ? false : true}
                                        style={{ paddingRight: "5px", marginBottom: "35px" }}
                                    />
                                    {newMode ? <Grid style={{ minHeight: "15px" }} /> : ""}
                                </AccordionDetails>
                                : [editMode ? <Grid style={{ minHeight: "115px" }} /> : ""]}
                        </Accordion>
                    </Grid>
                    {messstelleLoading ?
                        (
                            <TableContainer className={classes.heightScrolledTableBottom}>
                                <Table stickyHeader >
                                    <TableHead>
                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        ) : [
                            messstelleDaten != emptyMessstelle ?
                                <TableContainer className={classes.heightScrolledTableBottom}>
                                    <Table stickyHeader size="small" style={{ marginBottom: "50px" }} >
                                        <TableHead>
                                            <TableCell className={classes.tableHeadlineSub} style={{ maxWidth: "200px", width: "200px", backgroundColor: "white", fontWeight: "600" }}>Name </TableCell>
                                            <TableCell className={classes.tableHeadlineSub} style={{ maxWidth: "200px", width: "200px", backgroundColor: "white", fontWeight: "600" }} >Beschreibung</TableCell>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Bezeichnung</TableCell>
                                                <TableCell id='messstellenBezeichnung' data-cy='messstellen-bezeichnung-tablecell' >{messstelleDaten.name}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Umspannwerk</TableCell>
                                                <TableCell>{messstelleDaten.umspannwerk}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Schaltfeld</TableCell>
                                                <TableCell>{messstelleDaten.schaltfeld}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Breitengrad</TableCell>
                                                <TableCell>{messstelleDaten.breitengrad}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Längengrad</TableCell>
                                                <TableCell>{messstelleDaten.laengengrad}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Spannungsebene</TableCell>
                                                <TableCell>{messstelleDaten.spannungsebene}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Wandlerfaktor Strom</TableCell>
                                                <TableCell>{messstelleDaten.stromwandler}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Wandlerfaktor Spannung</TableCell>
                                                <TableCell>{messstelleDaten.spannungswandler}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}>Kommentar</TableCell>
                                                <TableCell>{messstelleDaten.kommentar}</TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}> &nbsp;</TableCell>
                                                <TableCell> </TableCell>
                                            </TableRow>
                                            <TableRow hover={true}>
                                                <TableCell style={{ maxWidth: "200px", width: "200px" }}> &nbsp;</TableCell>
                                                <TableCell> </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                : ""]}
                </Paper>
            </Grid>
            <Grid item md={4}>
                <Paper>
                    <Grid item container md={12}>
                        <Accordion expanded={editMode || newMode} style={{ height: "100%", width: "100%", marginBottom: "-5px" }}>
                            <AccordionSummary
                                expandIcon={<React.Fragment>
                                    <Button component={NavLink} to="/geraeteverwaltung/messgeraete" onClick={()=> dispatch(updateAktuellesMessgeraet(messgeraetDaten))}>
                                       { newMode || editMode ? <Add data-cy="add-messgeraet-button" fontSize="large" className={classes.accordionSummary} /> : <EditIcon fontSize="small" className={classes.accordionSummary} />}
                                    </Button>
                                </React.Fragment>}>
                                <Typography className={classes.tableHeadline} variant="h6" >Messgerät</Typography>
                            </AccordionSummary>
                            {editMode || newMode ?
                                <AccordionDetails>
                                    <Autocomplete
                                        fullWidth
                                        id="select-messgeraet"
                                        value={messgeraetDaten}
                                        noOptionsText={<React.Fragment>
                                            {messgeraetLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine unzugeordneten Messgeräte"}</React.Fragment>}
                                        onChange={(event, newValue) => dispatch(setGeraetDaten(newValue ? newValue : emptyGeraet))}
                                        inputValue={selectedMessgeraetInputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setSelectedMessgeraetInputValue(newInputValue);
                                        }}
                                        options={messgeraete}
                                        getOptionLabel={(option) => (option ? option.seriennummer : "")}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Messgerät"
                                                InputLabelProps={{ ...params.InputLabelProps }}
                                                InputProps={{ ...params.InputProps }}
                                                variant="outlined"
                                            />
                                        )}
                                        disabled={editMode || newMode ? false : true}
                                        style={{ paddingRight: "5px", marginBottom: "35px" }}
                                    />
                                </AccordionDetails>
                                : ""}
                        </Accordion>
                    </Grid>
                    {messgeraetLoading ?
                        (
                            <TableContainer className={classes.heightScrolledTableBottom}>
                                <Table stickyHeader style={{ overflow: "hidden" }}>
                                    <TableHead>
                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        )
                        : [messgeraetDaten != emptyGeraet ? (
                            <TableContainer className={classes.heightScrolledTableBottom}>
                                <Table stickyHeader size="small" style={{ marginBottom: "50px" }}>
                                    <TableHead>
                                        <TableCell className={classes.tableHeadlineSub} style={{ maxWidth: "200px", width: "200px", backgroundColor: "white", fontWeight: "600" }} >Name </TableCell>
                                        <TableCell className={classes.tableHeadlineSub} style={{ maxWidth: "200px", width: "200px", backgroundColor: "white", fontWeight: "600" }} >Beschreibung</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Seriennummer</TableCell>
                                            <TableCell id='messgeraetSeriennummer' data-cy='messgeraet-seriennummer-tablecell'>{messgeraetDaten.seriennummer}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Messgerättyp</TableCell>
                                            <TableCell>{
                                                getMessgeraetTyp(messgeraettypListe).map(x => x.hersteller)
                                                + " " +
                                                getMessgeraetTyp(messgeraettypListe).map(x => x.typ)
                                            }</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Herstellungsjahr</TableCell>
                                            <TableCell>{messgeraetDaten.herstellungsjahr}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Firmware</TableCell>
                                            <TableCell>{messgeraetDaten.firmware}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>MAC-Adresse</TableCell>
                                            <TableCell>{messgeraetDaten.macadresse}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>IP-Adresse</TableCell>
                                            <TableCell>{messgeraetDaten.ipadresse}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Subnetzmaske</TableCell>
                                            <TableCell >{messgeraetDaten.subnetzmaske}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Inbetriebnahmedatum</TableCell>
                                            <TableCell><InbetriebnahmeDatumAnzeige inbetriebnahmedatum={messgeraetDaten.inbetriebnahmedatum} isUTC={isUTC} /></TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Wartungsintervall</TableCell>
                                            <TableCell>{messgeraetDaten.wartungsintervall}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Zeitsynchronisationsart</TableCell>
                                            <TableCell>{messgeraetDaten.zeitsynchronisationsart}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Kommentar</TableCell>
                                            <TableCell>{messgeraetDaten.kommentar}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : ""]}
                </Paper>
            </Grid>
            <Grid item md={4}>
                <Paper>
                    <Grid item container md={12}>
                        <Accordion expanded={editMode || newMode} style={{ height: "100%", width: "100%", marginBottom: "-5px" }}>
                            <AccordionSummary
                                expandIcon={<React.Fragment>
                                    <Button component={NavLink} to="/geraeteverwaltung/router" onClick={() => dispatch(updateAktuellesRoutergeraet(routergeraetDaten))}>
                                    { newMode || editMode ? <Add data-cy="add-router-button" fontSize="large" className={classes.accordionSummary} /> : <EditIcon fontSize="small" className={classes.accordionSummary} />}
                                    </Button>
                                </React.Fragment>}>
                                <Typography className={classes.tableHeadline} variant="h6" >Router</Typography>
                            </AccordionSummary>
                            {editMode || newMode ?
                                <AccordionDetails>
                                    <Autocomplete
                                        fullWidth
                                        id="select-router"
                                        value={routergeraetDaten}
                                        noOptionsText={<React.Fragment>
                                            {routergeraetLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine unzugeordneten Router"}</React.Fragment>}
                                        onChange={(event, newValue) => dispatch(setRouterDaten(newValue ? newValue : emptyRouter))}
                                        inputValue={selectedRouterInputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setSelectedRouterInputValue(newInputValue);
                                        }}
                                        options={router}
                                        getOptionLabel={(option) => (option ? option.seriennummer : "")}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Routergerät"
                                                InputLabelProps={{ ...params.InputLabelProps }}
                                                InputProps={{ ...params.InputProps }}
                                                variant="outlined"
                                            />
                                        )}
                                        disabled={editMode || newMode ? false : true}
                                        style={{ paddingRight: "5px", marginBottom: "35px" }}
                                    />
                                </AccordionDetails>
                                : ""}
                        </Accordion>
                    </Grid>
                    {routergeraetLoading ?
                        (
                            <TableContainer className={classes.heightScrolledTableBottom}>
                                <Table stickyHeader style={{ overflow: "hidden" }}>
                                    <TableHead>
                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        )
                        : [routergeraetDaten != emptyRouter ? (
                            <TableContainer className={classes.heightScrolledTableBottom}>
                                <Table stickyHeader size="small" style={{ marginBottom: "50px" }}  >
                                    <TableHead>
                                        <TableCell className={classes.tableHeadlineSub} style={{ maxWidth: "200px", width: "200px", backgroundColor: "white", fontWeight: "600" }}>Name </TableCell>
                                        <TableCell className={classes.tableHeadlineSub} style={{ maxWidth: "200px", width: "200px", backgroundColor: "white", fontWeight: "600" }}>Beschreibung</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Seriennummer</TableCell>
                                            <TableCell id='routerSeriennummer' data-cy='router-seriennummer-tablecell' >{routergeraetDaten.seriennummer}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Routertyp</TableCell>
                                            <TableCell>{
                                                getRoutergeraetTyp(routergeraettypListe).map(x => x.hersteller)
                                                + " " +
                                                getRoutergeraetTyp(routergeraettypListe).map(x => x.typ)
                                            }</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Herstellungsjahr</TableCell>
                                            <TableCell>{routergeraetDaten.herstellungsjahr}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Firmware</TableCell>
                                            <TableCell>{routergeraetDaten.firmware}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>MAC-Adresse</TableCell>
                                            <TableCell>{routergeraetDaten.macadresse}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>IP-Adresse</TableCell>
                                            <TableCell>{routergeraetDaten.ipadresse}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Subnetzmaske</TableCell>
                                            <TableCell>{routergeraetDaten.subnetzmaske}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Inbetriebnahmedatum</TableCell>
                                            <TableCell>
                                                <InbetriebnahmeDatumAnzeige inbetriebnahmedatum={routergeraetDaten.inbetriebnahmedatum} isUTC={isUTC} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Wartungsintervall</TableCell>
                                            <TableCell>{routergeraetDaten.wartungsintervall}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Zeitsynchronisationsart</TableCell>
                                            <TableCell>{routergeraetDaten.zeitsynchronisationsart}</TableCell>
                                        </TableRow>
                                        <TableRow hover={true}>
                                            <TableCell style={{ maxWidth: "200px", width: "200px" }}>Kommentar</TableCell>
                                            <TableCell>{routergeraetDaten.kommentar}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : ""]}
                </Paper>
            </Grid>
        </Grid>
    );
}